/**
 * @generated SignedSource<<f48ed13a2280687e55036f19745e5d66>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type userDetailsQuery$variables = Record<PropertyKey, never>;
export type userDetailsQuery$data = {
  readonly userDetails: {
    readonly accounts: ReadonlyArray<{
      readonly accountId: string | null | undefined;
      readonly accountLabel: string | null | undefined;
      readonly accountType: string | null | undefined;
      readonly email: string | null | undefined;
      readonly envdAccountId: string | null | undefined;
      readonly phone: string | null | undefined;
      readonly properties: {
        readonly accreditations: {
          readonly eU: boolean;
          readonly eUGFHQB: boolean;
          readonly hRG: boolean;
          readonly lPA: boolean;
          readonly mSA: boolean;
          readonly nFAS: boolean;
          readonly oSF: boolean;
        } | null | undefined;
        readonly address: {
          readonly line1: string | null | undefined;
          readonly postcode: string | null | undefined;
          readonly state: string | null | undefined;
          readonly town: string | null | undefined;
        } | null | undefined;
        readonly entityName: string | null | undefined;
        readonly firstName: string | null | undefined;
        readonly lastName: string | null | undefined;
        readonly msaMemberNum: string | null | undefined;
        readonly nameId: string | null | undefined;
        readonly nlisAccountId: string | null | undefined;
        readonly nlisAccountType: string | null | undefined;
        readonly nlisUserId: string | null | undefined;
        readonly propertyName: string | null | undefined;
        readonly reAccreditationDate: string | null | undefined;
        readonly rego: string | null | undefined;
      } | null | undefined;
      readonly roles: ReadonlyArray<string | null | undefined> | null | undefined;
    } | null | undefined>;
    readonly defaultAccount: string;
    readonly email: string;
    readonly firstName: string;
    readonly isNewUser: boolean;
    readonly lastName: string;
    readonly mobilePhone: string;
    readonly preferences: {
      readonly notifications: {
        readonly receiveUnlockEmail: boolean | null | undefined;
        readonly receiveUnlockSms: boolean | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly receiveEmails: boolean;
    readonly signature: string;
    readonly termsAccepted: boolean;
  } | null | undefined;
};
export type userDetailsQuery = {
  response: userDetailsQuery$data;
  variables: userDetailsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserDetailType",
    "kind": "LinkedField",
    "name": "userDetails",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mobilePhone",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isNewUser",
        "storageKey": null
      },
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defaultAccount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "receiveEmails",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "termsAccepted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signature",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserPreferencesType",
        "kind": "LinkedField",
        "name": "preferences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationPreferenceType",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "receiveUnlockEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "receiveUnlockSms",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "accounts",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "envdAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountLabel",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountProperties",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nameId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nlisAccountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nlisUserId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nlisAccountType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rego",
                "storageKey": null
              },
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "propertyName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "msaMemberNum",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reAccreditationDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountAddress",
                "kind": "LinkedField",
                "name": "address",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "line1",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "town",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "state",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "postcode",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ClaimAccreditations",
                "kind": "LinkedField",
                "name": "accreditations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eU",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lPA",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "oSF",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mSA",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hRG",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nFAS",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eUGFHQB",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roles",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "userDetailsQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "userDetailsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "0dc9e780bb9fd7d3b3d4a58deb2b602c",
    "id": null,
    "metadata": {},
    "name": "userDetailsQuery",
    "operationKind": "query",
    "text": "query userDetailsQuery {\n  userDetails {\n    firstName\n    lastName\n    mobilePhone\n    isNewUser\n    email\n    defaultAccount\n    receiveEmails\n    termsAccepted\n    signature\n    preferences {\n      notifications {\n        receiveUnlockEmail\n        receiveUnlockSms\n      }\n    }\n    accounts {\n      envdAccountId\n      accountType\n      accountLabel\n      email\n      phone\n      accountId\n      properties {\n        nameId\n        nlisAccountId\n        nlisUserId\n        nlisAccountType\n        rego\n        firstName\n        lastName\n        entityName\n        propertyName\n        msaMemberNum\n        reAccreditationDate\n        address {\n          line1\n          town\n          state\n          postcode\n        }\n        accreditations {\n          eU\n          lPA\n          oSF\n          mSA\n          hRG\n          nFAS\n          eUGFHQB\n        }\n      }\n      roles\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "56593649b6368eb1ba890c31c44ce2d7";

export default node;
